(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-realisation-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(gallery) {
      if (gallery.dataset.mmGalleryReady === 'true') return;
      gallery.dataset.mmGalleryReady = 'true';
      const image = gallery.querySelector('.mm-realisation-hero__main-image');
      const caption = gallery.querySelector('.mm-realisation-hero__caption');
      if (!image) return;
      gallery.querySelectorAll('.mm-realisation-hero__thumbnails button').forEach((button) => {
        button.addEventListener('click', () => {
          image.srcset = button.dataset.imageSrcset;
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          if (caption) caption.textContent = button.dataset.imageAlt;
          gallery.querySelectorAll('.mm-realisation-hero__thumbnails button').forEach((other) => {
            const selected = other === button;
            other.classList.toggle('is-active', selected);
            other.setAttribute('aria-pressed', String(selected));
          });
        });
      });
    }

    function scan(scope) {
      scope.querySelectorAll('.mm-realisation-hero__media').forEach(initialize);
      if (scope.matches?.('.mm-realisation-hero__media')) initialize(scope);
    }

    scan(document);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-realisations-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const compact = matchMedia('(max-width: 999px)');
    const roots = new Set();

    function syncPanels() {
      roots.forEach((root) => {
        if (!root.isConnected) {
          roots.delete(root);
          return;
        }
        const panel = root.querySelector('.mm-realisations__filter-panel');
        if (panel) panel.open = !compact.matches;
      });
    }

    function initialize(root) {
      if (root.dataset.mmListReady === 'true') return;
      root.dataset.mmListReady = 'true';
      roots.add(root);
      const panel = root.querySelector('.mm-realisations__filter-panel');
      if (panel) panel.open = !compact.matches;
      let active;
      try { active = JSON.parse(root.dataset.activeTags || '[]') || []; } catch { active = []; }
      const activeHandles = (root.dataset.activeHandles || '').split(',');
      active = active.map((name, index) => ({ name, handle: activeHandles[index] }));
      const grid = root.querySelector('.mm-realisations__grid');
      root.querySelectorAll('.mm-realisations__views button').forEach((button) => {
        button.addEventListener('click', () => {
          if (!grid) return;
          grid.classList.toggle('is-list', button.dataset.view === 'list');
          root.querySelectorAll('.mm-realisations__views button').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        });
      });
      root.querySelectorAll('.mm-realisations__filter-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const selected = link.dataset.tag;
          const group = link.dataset.group + ':';
          const next = active.filter((tag) => !tag.name.startsWith(group));
          if (!active.some((tag) => tag.name === selected)) next.push({ name: selected, handle: link.dataset.tagHandle });
          const handles = next.map((tag) => tag.handle).filter(Boolean);
          location.assign(root.dataset.blogUrl + (handles.length ? '/tagged/' + handles.join('+') : ''));
        });
      });
    }

    function scan(scope) {
      scope.querySelectorAll('.mm-realisations').forEach(initialize);
      if (scope.matches?.('.mm-realisations')) initialize(scope);
    }

    scan(document);
    compact.addEventListener('change', syncPanels);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
